import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../../../assets/stylesheets/ClubSlide/MainClub.scss';
import unionIcon from '../../../../assets/images/club/unionMark.svg';
import groupIcon from '../../../../assets/images/club/group.svg';
import infoIcon from '../../../../assets/images/club/infoIcon.svg';
import tutorialIcon from '../../../../assets/images/club/2.svg';
import UnionMenu from './UnionMenu'
import { useSelector, useDispatch } from "react-redux";
import { getUnion, getRoleInCurrentClub, getClubUnionId, getCurrentClub } from "../../../../store/selectors";
import { leaveClub } from "../../../../store/actionCreators/club";
import { openDialog } from '../../../../store/actionCreators/dialog';
import parameters from "../../../../config/parameters";


const TopRow = ({ to }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const [unionMenuIsOpened, setUnionMenuIsOpened] = useState(false);
    const clubUnionId = useSelector(getClubUnionId);
    const roleInClub = useSelector(getRoleInCurrentClub);
    const dispatch = useDispatch();
    const clubInfo = useSelector(getCurrentClub);
    const isAdminMember = [parameters.clubRoles.OWNER, parameters.clubRoles.MANAGER].includes(roleInClub);
    const openUnionMenu = e => {
        setUnionMenuIsOpened(true);
        setTimeout(() => { setUnionMenuIsOpened(false) }, 500)
    };
    const openClubInfo = () => {
        dispatch(openDialog('clubInfo',
            {
                smallSize: true,
                description: clubInfo.description
            }));
    }

     const redirect = useCallback((e) => {
         e.preventDefault();
         history.push(`/home`);
         dispatch(leaveClub());
     }, []);

    return (
        <React.Fragment>
            <div className={`topRow`}>
                <Link to={to || `/home`} onClick={redirect}>
                    <span className={'arrowIcon'}>
                        <FontAwesomeIcon icon={faChevronLeft} color="white" className="fa chevron-left"></FontAwesomeIcon>
                    </span>
                </Link>
                <span className={`title`}>{t('club.text')}</span>
                <span>
                    {/* <Link to={`/tutorial`}><img src={tutorialIcon} className={`icon`} /></Link> */}
                    <img src={infoIcon} className={`icon`} name="infoIcon" onClick={ openClubInfo } />
                    {roleInClub === parameters.clubRoles.PLAYER &&
                        <img src={groupIcon} className={`icon`} name="groupIcon" onClick={() => dispatch(openDialog('memberMenu'))} />
                    }
                    {/* {isAdminMember &&
                        <React.Fragment>
                            {!!clubUnionId ?
                                <Link to={`/union/${clubUnionId}`}><img src={unionIcon} className={`icon`} name="unionIcon" /></Link> :
                                <img src={unionIcon} className={`icon`} name="unionIcon" onClick={openUnionMenu} />
                            }
                        </React.Fragment>
                    } */}
                </span>
            </div>
            <UnionMenu isOpened={unionMenuIsOpened} />
        </React.Fragment>
    );
};

export default TopRow;
